import React from "react";
import GlobalStyle from "../../styles/GlobalStyle";
import { FontSizes } from "../../styles/responsive";
import { V2ReportStyle } from "../../styles/V2ReportStyle";
import { PALLETTE } from "../../utils/theme";
import { RightTickmarkSvg } from "../../utils/Svgs";

const RenderCheckList = ({
  title,
  isChecked = false,
  width = "90%",
}: {
  title: string;
  isChecked: boolean;
  width?: string | number;
}) => {
  return (
    <div
      style={{
        ...V2ReportStyle.flexRowCenter,
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <span
        style={{
          ...GlobalStyle.blackMediumText,
          fontSize: "1.7rem",
          width: width,
        }}
      >
        {title}
      </span>

      <div
        style={{
          ...V2ReportStyle.checkBox,
          borderColor: isChecked ? PALLETTE.orange : PALLETTE.gray,
          backgroundColor: PALLETTE.white,
          cursor: isChecked ? "pointer" : "default",
          padding: 0,
          borderStyle: "solid",
        }}
      >
        {isChecked && <RightTickmarkSvg />}
      </div>
    </div>
  );
};

export default RenderCheckList;
